// extracted by mini-css-extract-plugin
export default {"mainHolder":"SchoolGroupTokenUsage_mainHolder__rRKuo","rowHolder":"SchoolGroupTokenUsage_rowHolder__l3qrL"};